"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteriskAutopauseEnum = void 0;
var AsteriskAutopauseEnum;
(function (AsteriskAutopauseEnum) {
    AsteriskAutopauseEnum["YES"] = "yes";
    AsteriskAutopauseEnum["NO"] = "no";
    AsteriskAutopauseEnum["ALL"] = "all";
})(AsteriskAutopauseEnum = exports.AsteriskAutopauseEnum || (exports.AsteriskAutopauseEnum = {}));
